export default __webpack_public_path__ + "2f517e09eb2ca6650ff5bec5a95157ab.svg";